import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const SharedViewNotLoadedSnapshot: FC = () => {
  const {
    canvasGraph: {
      emptyGraph: {
        sharedViewNotLoadedSnapshot: msgSharedViewNotLoadedSnapshot,
      },
    },
  } = useLocale();

  return (
    <>
      <p className='text-bold text-uppercase text-danger'>
        <i className='fa fa-exclamation-circle mr-2.5' />
        {msgSharedViewNotLoadedSnapshot.title}
      </p>
      <p>{msgSharedViewNotLoadedSnapshot.description}</p>
    </>
  );
};
